<template>
  <div id="livetrack-map" class="mc-liveview--fo-map">
    <div v-if="isLoading" class="loading-overlay">
      <div v-if="!getLoaderLogoPath" class="spinner"></div>
      <img v-else :src="getLoaderLogoPath" alt="Loading..." class="loading-logo blinking" />
    </div>
    <div
      v-if="!isLoading && detailTripHistories.data.length > 0"
      class="mc-liveview--fo-map-playback"
    >
      <div class="d-flex justify-content-between">
        <span><i class="mc-fa icon-outline_driving-hours"></i></span>
        <div>
          <p>Riwayat Perjalanan</p>
          <span class="text-muted">Klik pada rute untuk informasi lebih lanjut.</span>
        </div>
      </div>
      <b-button variant="primary" @click="startPlayback"> Playback </b-button>
    </div>
    <div class="map-relative">
      <GmapMap
        id="map"
        ref="gmapRef"
        :center="$store.state.map.center"
        :zoom="parseFloat($store.state.map.zoom)"
        :options="gMapOptions"
        :map-type-id="$store.state.fleets.mapMode"
        class="mc-liveview--fo-map-wrapper"
      >
        <!-- MARKER FO -->
        <gmap-custom-marker
          v-for="marker in filteredMarkers"
          :key="marker.id"
          :marker="{
            lat: Number(marker.address.geolocation.coordinate.latitude),
            lng: Number(marker.address.geolocation.coordinate.longitude),
          }"
          :offsetY="40"
        >
          <div class="text-center">
            <span
              v-if="marker.type == 'START' && marker.status != 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico"
            >
              <img
                :src="require(`@/assets/images/marker/fill_white_home.svg`)"
                alt="mceasy-lifeview-car-icon"
              />
            </span>
            <span
              v-else-if="marker.type == 'START' && marker.status == 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico"
            >
              <img
                :src="require(`@/assets/images/marker/fill_white_home.svg`)"
                alt="mceasy-lifeview-car-icon"
              />
            </span>
            <span
              v-else-if="marker.type == 'END' && marker.status != 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico"
            >
              <img
                :src="require(`@/assets/images/marker/fill_white_home.svg`)"
                alt="mceasy-lifeview-car-icon"
              />
            </span>
            <span
              v-else-if="marker.type == 'END' && marker.status == 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico"
            >
              <img
                :src="require(`@/assets/images/marker/fill_white_home.svg`)"
                alt="mceasy-lifeview-car-icon"
              />
            </span>
            <span
              v-else-if="marker.type == 'DEFAULT' && marker.status != 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico mc-liveview--fo-map-marker-ico-uncompleted"
            >
              <i>{{ marker.order }}</i>
            </span>
            <span
              v-else-if="marker.type == 'DEFAULT' && marker.status == 'COMPLETED'"
              class="mc-liveview--fo-map-marker-ico mc-liveview--fo-map-marker-ico-completed"
            >
              <i>{{ marker.order }}</i>
            </span>
            <span v-else class="mc-liveview--fo-map-marker-ico">
              <img
                :src="require(`@/assets/images/marker/fill_black_home.svg`)"
                alt="mceasy-lifeview-car-icon"
              />
            </span>
            <div class="mc-liveview--fo-map-marker">
              <strong>{{ marker.address.name }}</strong>
            </div>
          </div>
        </gmap-custom-marker>

        <!-- MARKER STOP -->
        <gmap-custom-marker
          v-for="(row, index) in stopPositions"
          :key="row + index"
          :marker="{
            lat: Number(row.lat),
            lng: Number(row.lng),
          }"
          :offsetY="40"
        >
          <div class="text-center">
            <img
              role="button"
              alt="Stop Icon"
              src="@/assets/images/caricon/stop-icon.svg"
              @click="openInfo(row.lat, row.lng, row.totalHourStop, row.date)"
            />
          </div>
        </gmap-custom-marker>

        <GmapPolyline
          v-for="(polyline, index) in polylines"
          :key="index"
          :path="polyline.path"
          :options="polyline.options"
          @click="showSpeedInfo(polyline.start.speed, polyline.start.sentOn, $event)"
        />

        <gmap-custom-marker
          v-if="makerVehicle && !isLoading"
          :marker="{
            lat: Number(makerVehicle.latitude),
            lng: Number(makerVehicle.longitude),
          }"
          :offsetY="25"
        >
          <div class="text-center">
            <div class="rounded bottom-icon-shape">
              <h6 class="p-1">
                <strong>{{ makerVehicle.licensePlate }}</strong>
              </h6>
            </div>
            <img
              :src="
                makerVehicle.calculatedMotionStatus === 'P'
                  ? require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-red.png`)
                  : makerVehicle.calculatedMotionStatus === 'A'
                  ? require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-blue.png`)
                  : makerVehicle.calculatedMotionStatus === 'M'
                  ? require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-green.png`)
                  : makerVehicle.calculatedMotionStatus === 'I'
                  ? require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-orange.png`)
                  : makerVehicle.calculatedMotionStatus === 'O' ||
                    makerVehicle.calculatedMotionStatus === 'U'
                  ? require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-grey.png`)
                  : require(`@/assets/images/vehicles/${makerVehicle.vehicle.vehicleType.icon}/${makerVehicle.vehicle.vehicleType.icon}-dark-grey.png`)
              "
              :style="`transform: rotate(${parseInt(makerVehicle.direction)}deg);`"
              alt="mceasy-lifeview-car-icon"
            />
          </div>
        </gmap-custom-marker>
        <GmapInfoWindow
          :position="infoWindow.position"
          :opened="infoWindow.status"
          :options="{
            ariaLabel: 'infoWindow',
          }"
        >
          <div v-if="infoWindow.type === 'totalHourStop'" class="infowindow-map">
            <div class="__header">
              <h6>Berhenti Kendaraan</h6>
              <div class="__btn-close" @click="CloseInfo">
                <i class="mc-fa icon-outline_close" />
              </div>
            </div>
            <div class="__body">
              <div class="__wrapper">
                <div class="__title">Waktu</div>
                <div class="__content">
                  {{ infoWindow.date }}
                </div>
              </div>
              <div class="__wrapper">
                <div class="__title">
                  {{ $t('liveView.modal.stopDuration') }}
                </div>
                <div class="__content">
                  {{ infoWindow.totalHourStop }}
                </div>
              </div>
              <div class="__wrapper">
                <div class="__title">Detail Lokasi</div>
                <div class="__content">
                  {{ infoWindow.address }}
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="infoWindow.type === 'speed'" class="infowindow-map">
            <div class="__header">
              <h6>Kecepatan</h6>
              <div class="__btn-close" @click="CloseInfo">
                <i class="mc-fa icon-outline_close" />
              </div>
            </div>
            <div class="__body">
              <div class="__wrapper">
                <div class="__title">Waktu</div>
                <div class="__content">
                  {{
                    formatIndexDate(infoWindow.sentOn).date +
                    ' ' +
                    formatIndexDate(infoWindow.sentOn).time
                  }}
                </div>
              </div>
              <div class="__wrapper">
                <div class="__title">
                  {{ $t('liveView.infoWindow.speed') }}
                </div>
                <div class="__content">{{ infoWindow.speed }} Km/{{ $t('global.time.hours') }}</div>
              </div>
              <div class="__wrapper">
                <div class="__title">Detail Lokasi</div>
                <div class="__content">
                  {{ infoWindow.address }}
                </div>
              </div>
            </div>
          </div>
        </GmapInfoWindow>
      </GmapMap>
      <MapActionBtns @center="fitMapBounds" />
    </div>

    <div class="mc-liveview--fo-footer">
      <span>
        Terakhir diupdate pada :
        {{ formatIndexDate(currentDateTime).date + ' ' + formatIndexDate(currentDateTime).time }}
      </span>
      <div>
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img ref="imgCopyrightLogo" :src="getAsset('copyrightLogo', 'general')" alt />
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import moment from 'moment'

import { Helper } from '@/mixin/helper'
import responsive from '@/mixin/responsive'

import { formatIndexDate } from '@/helpers/tzDate'

import { GetAddressData } from '@/services/api/map'
import { GET_VEHICLE_STATUSES_LIVETRACK, GET_DETAIL_TRIP_HISTORIES } from '@/services/api/fleet'

import MapActionBtns from './components/MapActionBtns'

export default {
  name: 'GmapFleet',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
    MapActionBtns,
  },
  mixins: [Helper, responsive],
  props: {
    detailData: {
      type: Object,
      required: true,
    },
    detailVehicle: {
      type: Object,
      required: true,
    },
    currentDateTime: {
      type: String,
      required: true,
    },
    authToken: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['update:currentDateTime'],
  data() {
    return {
      gMapOptions: {
        minZoom: 3,
        mapTypeControl: false,
        scaleControl: true,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: false,
        scrollwheel: true,
        styles: [
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#d5e6f9',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#d5e6f9',
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
              {
                weight: '1',
              },
              {
                color: '#d5e6f9',
              },
              {
                saturation: '0',
              },
            ],
          },
        ],
      },
      makerFO: [],
      makerVehicle: null,
      rawLocations: [],
      polylines: [],
      infoWindow: {
        status: false,
        type: 'totalHourStop',
        position: { lat: 0, lng: 0 },
        totalHourStop: '',
        speed: 0,
        sentOn: '',
        address: '',
        date: '',
      },
      stopPositions: [],
      isLoading: true,
      currentPolylineIndex: 0,
      isPlaybackRunning: false,
      isOpenStopWindow: false,
      isOpenSpeedWindow: false,
    }
  },
  computed: {
    google: gmapApi,
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    filteredMarkers() {
      const addressIdMap = new Map()

      const maxAddressIds = this.makerFO.reduce((acc, marker) => {
        const addressId = marker.address.id
        const currentMax = acc.get(addressId) || { id: -1 }

        if (marker.address.id > currentMax.id) {
          acc.set(addressId, marker)
        }

        return acc
      }, new Map())

      const filteredMarkers = this.makerFO.filter((marker) => {
        const addressId = marker.address.id
        const maxMarker = maxAddressIds.get(addressId)

        if (maxMarker && maxMarker.address.id === marker.address.id) {
          if (marker.type === 'START' || marker.type === 'END') {
            addressIdMap.set(addressId, marker)
            return true
          } else if (!addressIdMap.has(addressId)) {
            addressIdMap.set(addressId, marker)
            return true
          }
        }

        return false
      })

      return filteredMarkers
    },
    getLoaderLogoPath() {
      return this.getAsset('secondaryLogo', 'sidebarMinimize')
    },
  },

  watch: {
    detailVehicle: {
      handler(newValue) {
        if (newValue && newValue.id) {
          this.getVehicleStatuses()
        }
      },
      deep: true,
    },
  },

  mounted() {
    clearInterval(this.tripHistoryInterval)
    this.adjustImageSize()
  },

  beforeUpdate() {
    let order = 1
    const markerFO = this.detailData.sequence.map((marker) => {
      if (marker.type === 'DEFAULT') {
        const newMarker = {
          ...marker,
          order,
        }
        order++
        return newMarker
      }
      return marker
    })
    this.makerFO = markerFO
  },
  updated() {
    this.fitMapBounds()
  },
  beforeDestroy() {
    clearInterval(this.tripHistoryInterval)
  },

  methods: {
    formatIndexDate,
    getApolloContext() {
      return {
        headers: {
          Authorization: this.authToken ? `Bearer ${this.authToken}` : undefined,
        },
      }
    },
    formattedDateRange(start, end) {
      if (start.isSame(end, 'day')) {
        return `${start.format('DD MMM YYYY, HH:mm')} - ${end.format('HH:mm')}`
      } else {
        return `${start.format('DD MMM YYYY, HH:mm')} - ${end.format('DD MMM YYYY, HH:mm')}`
      }
    },
    getCurrentDateTime() {
      const now = new Date()
      const isoDateTime = now.toISOString()
      return isoDateTime
    },

    async getVehicleStatuses() {
      this.stopPlayback()
      this.resetPolyline()
      const vehicleId = await this.detailVehicle.id
      const res = await this.$apollo.query({
        query: GET_VEHICLE_STATUSES_LIVETRACK,
        fetchPolicy: 'no-cache',
        context: this.getApolloContext(),
        variables: {
          filter: {
            vehicleId: [parseInt(vehicleId)],
          },
        },
      })
      this.makerVehicle = res.data.vehicleStatuses.vehicleStatuses?.[0]
      this.getTripHistory()
    },

    async getTripHistory() {
      try {
        this.isLoading = true
        const vehicleId = this.detailData.vehicle.id
        const startDate = this.detailData.actual_departure_on
        const endDate = this.detailData.actual_arrival_on ?? this.now()

        const detailTripHistories = await this.$apollo.query({
          query: GET_DETAIL_TRIP_HISTORIES,
          fetchPolicy: 'no-cache',
          context: this.getApolloContext(),
          variables: {
            filter: {
              vehicleId: parseInt(vehicleId),
              startDate: this.momentToISOString(startDate),
              endDate: this.momentToISOString(endDate),
            },
          },
        })

        this.detailTripHistories = detailTripHistories.data.detailTripHistories.detailTripHistories
        const lastPosition = this.detailTripHistories?.data?.slice().reverse()[0]

        if (lastPosition) {
          this.makerVehicle = {
            ...this.makerVehicle,
            latitude: lastPosition.latitude,
            longitude: lastPosition.longitude,
            direction: lastPosition.direction,
            calculatedMotionStatus:
              this.detailData.status.raw_type !== 'ENDED'
                ? this.makerVehicle.calculatedMotionStatus
                : 'H',
          }
        }
        this.drawPolyline()
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    drawPolyline() {
      clearInterval(this.tripHistoryInterval)
      if (!this.detailTripHistories?.data?.length) return

      this.polylines = []

      let segment = []

      for (let i = 0; i < this.detailTripHistories.data.length; i++) {
        const point = this.detailTripHistories.data[i]

        const lat = Number(point.latitude)
        const lng = Number(point.longitude)

        if (!this.isValidLatLng(lat, lng)) continue

        segment.push({ ...point, latitude: lat, longitude: lng })

        if (segment.length >= 2) {
          const start = segment[segment.length - 2]
          const end = segment[segment.length - 1]

          let color
          if (start.speed >= 0 && start.speed <= 20) {
            color = '#f41d00'
          } else if (start.speed > 20 && start.speed <= 40) {
            color = '#f64a33'
          } else if (start.speed > 40 && start.speed <= 60) {
            color = '#ffa133'
          } else if (start.speed > 60 && start.speed <= 80) {
            color = '#71b099'
          } else if (start.speed > 80) {
            color = '#137c55'
          }

          this.polylines.push({
            path: [
              { lat: start.latitude, lng: start.longitude },
              { lat: end.latitude, lng: end.longitude },
            ],
            options: {
              strokeColor: color,
              strokeOpacity: 1.0,
              strokeWeight: 5,
            },
            start,
            end,
          })
        }
      }
      const stopPositions = this.detailTripHistories.stoppage.map((item) => {
        const start = new Date(item.startDate)
        const end = new Date(item.endDate)
        const diffMs = end - start
        const totalSeconds = Math.floor(diffMs / 1000)

        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
        const seconds = String(totalSeconds % 60).padStart(2, '0')

        return {
          lat: item.stopLat,
          lng: item.stopLong,
          totalHourStop: `${hours}:${minutes}:${seconds}`,
          date: this.formattedDateRange(moment(item.startDate), moment(item.endDate)),
        }
      })
      this.stopPositions = stopPositions
      this.startTripHistoryInterval()
      this.isLoading = false
    },

    async showSpeedInfo(speed, sentOn, event) {
      console.log(speed, sentOn, event)
      if (this.isPlaybackRunning) return
      this.CloseInfo()
      this.$refs.gmapRef.$mapPromise.then((map) => {
        const currentZoom = map.getZoom()
        map.setZoom(currentZoom)
      })

      try {
        const address = await GetAddressData(event.latLng.lat(), event.latLng.lng())
        this.infoWindow.address = address.display_name
      } catch (error) {
        this.infoWindow.address = '-'
      }

      this.infoWindow.status = true
      this.infoWindow.type = 'speed'
      this.infoWindow.position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.infoWindow.speed = speed
      this.infoWindow.sentOn = sentOn
      this.isOpenSpeedWindow = true
    },
    async openInfo(lat, lng, totalHourStop, date) {
      if (this.isPlaybackRunning) return
      this.CloseInfo()
      await this.$nextTick()

      this.$refs.gmapRef.$mapPromise.then((map) => {
        const currentZoom = map.getZoom()
        map.setZoom(currentZoom)
      })

      try {
        const address = await GetAddressData(lat, lng)
        this.infoWindow.address = address.display_name
      } catch (error) {
        this.infoWindow.address = '-'
      }

      this.infoWindow.date = date

      this.infoWindow.status = true
      this.infoWindow.type = 'totalHourStop'
      this.infoWindow.position = { lat, lng }
      this.infoWindow.totalHourStop = totalHourStop
      this.isOpenStopWindow = true
    },
    CloseInfo() {
      this.infoWindow.status = false
      this.isOpenStopWindow = false
      this.isOpenSpeedWindow = false
    },
    startPlayback() {
      this.CloseInfo()
      this.isOpenStopWindow = false
      this.isPlaybackRunning = true
      const lastPosition = { ...this.makerVehicle }

      if (this.playbackInterval) {
        clearInterval(this.playbackInterval)
      }

      let currentDetailIndex = 0

      const tripHistory = this.detailTripHistories.data
      if (tripHistory) {
        this.playbackInterval = setInterval(() => {
          const currentDetail = tripHistory[currentDetailIndex]

          if (currentDetail) {
            this.makerVehicle = {
              ...this.makerVehicle,
              latitude: currentDetail.latitude,
              longitude: currentDetail.longitude,
              direction: currentDetail.direction,
              calculatedMotionStatus: currentDetail.calculatedMotionStatus || 'H',
            }

            currentDetailIndex++
          } else {
            clearInterval(this.playbackInterval)
            this.makerVehicle = lastPosition
            this.isPlaybackRunning = false
          }
        }, 100)
      }
    },

    fitMapBounds() {
      if (this.isPlaybackRunning || this.isOpenStopWindow || this.isOpenSpeedWindow) return
      const bounds = new this.google.maps.LatLngBounds()

      this.filteredMarkers.forEach((marker) => {
        const position = new this.google.maps.LatLng(
          marker.address.geolocation.coordinate.latitude,
          marker.address.geolocation.coordinate.longitude
        )
        bounds.extend(position)
      })

      this.polylines.forEach((polyline) => {
        polyline.path.forEach((coordinate) => {
          if (coordinate.lat !== null && coordinate.lng !== null) {
            const position = new this.google.maps.LatLng(coordinate.lat, coordinate.lng)
            bounds.extend(position)
          }
        })
      })

      this.$refs.gmapRef.$mapPromise.then((map) => {
        map.fitBounds(bounds)
      })
    },
    startTripHistoryInterval() {
      try {
        if (
          this.detailData &&
          this.detailData.status &&
          this.detailData.status.raw_type !== 'ENDED'
        ) {
          this.isLoading = true
          this.$emit('update:currentDateTime', this.getCurrentDateTime())
          this.isPlaybackRunning = false
          this.CloseInfo()
          this.tripHistoryInterval = setInterval(() => {
            if (!this.isPlaybackRunning) {
              this.getVehicleStatuses()
            }
          }, 300000)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    resetPolyline() {
      this.polylines = []
      this.stopPositions = []
    },
    stopPlayback() {
      this.isPlaybackRunning = false
      clearInterval(this.playbackInterval)
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgCopyrightLogo, 21, 125)
    },

    isValidLatLng(lat, lng) {
      return typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep([aria-label='infoWindow']) {
  padding: 0 !important;

  .gm-style-iw-chr {
    display: none;
  }

  .gm-style-iw-d {
    display: contents;

    .infowindow-map {
      background: $mep-color-text-400;
      padding: 12px;
      color: $white !important;
      max-width: 300px;

      .__header {
        display: flex;
        justify-content: space-between;
        font-size: 13px;

        border-bottom: 1px solid $mep-color-text-200;
        margin-bottom: 10px;

        h6 {
          color: $white;
        }

        .__btn-close {
          padding: 3px;
          cursor: pointer;
          height: fit-content;

          .mc-fa::before {
            font-size: 13px;
            color: $white;
          }
        }
      }

      .__body {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .__title {
          color: $mep-color-text-200;
        }
      }
    }
  }
}

.mc-liveview--fo-map-wrapper :deep(.gm-bundled-control-on-bottom) {
  margin: 70px 20px !important;
}
</style>
